import { ListItem } from '../../shared/models/list-item.model';

import { InstrumentationData } from '../../shared/instrumentation/instrumentation-data.model';
import { InstrumentationParam, InstrumentationParams, KnownAreas, KnownInstrumentationEvents } from '../../shared/instrumentation/instrumentation.service';
import { KnownWorkloadReferralNames } from '../../shared/models/known-workload-referral-names.model';

export class SiteItem implements ListItem {
    private static readonly groupReference: string = 'GroupReference';

    public isGroup: boolean;

    /**
     * Creates a new SiteItem
     * @param id                    Id of the site, used for instrumentation purposes.
     * @param type                  Type of site (Group, etc.).
     * @param acronym               Two letter acronym for the site's title. Used when a bannerImage is unavailable.
     * @param bannerImageUrl        Url to display the banner image for the site.
     * @param bannerColor           Color displayed behind the banner image. Used to generate an icon when an image is unavailable.
     * @param time                  The last visited timestamp
     * @param url                   Url of the site.
     * @param title                 Title of the site.
     */
    constructor(
        public id: string,
        public type: string,
        public acronym: string,
        public bannerImageUrl: string,
        public bannerColor: string,
        public time: Date,
        public url: string,
        public title: string
    ) {
        this.isGroup = SiteItem.groupReference === this.type;
    }

    public static distributionFromSiteTypes(types: Array<string>): string {
        if (!types) {
            return '';
        }

        return types.reduce((combined, current, index) => combined + (index === 0 ? '' : ';') + current, '');
    }

    public static distributionFromSiteItems(items: Array<Readonly<SiteItem>>): string {
        if (!items) {
            return '';
        }

        return SiteItem.distributionFromSiteTypes(items.map(item => item.type));
    }

    public getId(): string { return this.id; }

    public getClickData(index: number, listId: string): InstrumentationData {
        const params: InstrumentationParams = {};

        params[InstrumentationParam.ElementId] = `${listId}_${index}`;
        params[InstrumentationParam.ItemId] = this.id;
        params[InstrumentationParam.Index] = index.toString();
        params[InstrumentationParam.ItemCategory] = this.type;
        params[InstrumentationParam.Referral] = KnownWorkloadReferralNames.SharePoint;
        params[InstrumentationParam.Area] = KnownAreas.Sites;
        params[InstrumentationParam.ListId] = listId;

        return {
            eventName: KnownInstrumentationEvents.SharePointSiteClick,
            params,
            metrics: []
        };
    }
}
